import type { BlockH5P } from 'shared-types';

type LocaleData = BlockH5P['locales'][string];

const defaultBlockData = {
  format: 'html' as const,
  isMandatory: false,
  isTask: true,
  pointsWeight: 2,
  version: 2
};

const translatable: LocaleData['translatable'] = {
  openFullScreenMessage: ''
};
const defaultLocaleData: LocaleData = {
  aspectRatio: null,
  editorIframeSetZoomWidth: null,
  enableFullScreen: 'disabled' as const,
  file: null,
  minHeight: 600,
  numberOfTasks: 1,
  scale: null,
  selectZoom: null,
  translatable,
  url: null,
  useAspectRatio: null
};

const localePlaceholders = {
  aspectRatio: '{{ locales.aspectRatio }}' as const,
  editorIframeSetZoomWidth: '{{ locales.editorIframeSetZoomWidth }}' as const,
  enableFullScreen: '{{ locales.enableFullScreen }}' as const,
  file: '{{ locales.file }}' as const,
  minHeight: '{{ locales.minHeight }}' as const,
  numberOfTasks: '{{ locales.numberOfTasks }}' as const,
  scale: '{{ locales.scale }}' as const,
  selectZoom: '{{ locales.selectZoom }}' as const,
  openFullScreenMessage:
    '{{ locales.translatable.openFullScreenMessage }}' as const,
  url: '{{ locales.url }}' as const,
  useAspectRatio: '{{ locales.useAspectRatio }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockH5PData: BlockH5P = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockH5P['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
